/* ../lib/components/parts/MockView/MockView.svelte generated by Svelte v3.18.2 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	text
} from "svelte/internal";

import { onMount } from "svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-fnonfq-style";
	style.textContent = ".main.svelte-fnonfq{position:fixed;top:0;left:0;-webkit-overflow-scrolling:touch;width:100%;height:100%;background-color:white}iframe.svelte-fnonfq,webview.svelte-fnonfq{overflow:auto;border:none;width:inherit;height:inherit}";
	append(document.head, style);
}

// (41:2) {:else}
function create_else_block(ctx) {
	let t0;
	let t1;
	let t2;

	return {
		c() {
			t0 = text("settings.target = `");
			t1 = text(/*target*/ ctx[0]);
			t2 = text("`, not defined. 'browser' or 'electron'\r\n    available.");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, t2, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*target*/ 1) set_data(t1, /*target*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
		}
	};
}

// (39:34) 
function create_if_block_1(ctx) {
	let webview_1;
	let webview_1_src_value;

	return {
		c() {
			webview_1 = element("webview");
			if (webview_1.src !== (webview_1_src_value = /*src*/ ctx[1])) attr(webview_1, "src", webview_1_src_value);
			attr(webview_1, "nodeintegration", "");
			attr(webview_1, "class", "svelte-fnonfq");
		},
		m(target, anchor) {
			insert(target, webview_1, anchor);
			/*webview_1_binding*/ ctx[3](webview_1);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 2 && webview_1.src !== (webview_1_src_value = /*src*/ ctx[1])) {
				attr(webview_1, "src", webview_1_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(webview_1);
			/*webview_1_binding*/ ctx[3](null);
		}
	};
}

// (37:2) {#if target === 'browser'}
function create_if_block(ctx) {
	let iframe;
	let iframe_src_value;

	return {
		c() {
			iframe = element("iframe");
			if (iframe.src !== (iframe_src_value = /*src*/ ctx[1])) attr(iframe, "src", iframe_src_value);
			attr(iframe, "title", "mock");
			attr(iframe, "class", "svelte-fnonfq");
		},
		m(target, anchor) {
			insert(target, iframe, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 2 && iframe.src !== (iframe_src_value = /*src*/ ctx[1])) {
				attr(iframe, "src", iframe_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(iframe);
		}
	};
}

function create_fragment(ctx) {
	let div;

	function select_block_type(ctx, dirty) {
		if (/*target*/ ctx[0] === "browser") return create_if_block;
		if (/*target*/ ctx[0] === "electron") return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "main svelte-fnonfq");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { target = "browser" } = $$props;
	let { src } = $$props;
	let webview;

	onMount(() => {
		if (target === "electron") {
			webview.addEventListener("dom-ready", () => {
				webview.openDevTools();
			});
		}
	});

	function webview_1_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(2, webview = $$value);
		});
	}

	$$self.$set = $$props => {
		if ("target" in $$props) $$invalidate(0, target = $$props.target);
		if ("src" in $$props) $$invalidate(1, src = $$props.src);
	};

	return [target, src, webview, webview_1_binding];
}

class MockView extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-fnonfq-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { target: 0, src: 1 });
	}
}

export default MockView;